<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 col-lg-3">
                <div class="card">
                    <div class="card-body">
                        <div class="w-75 m-auto">
                            <img class="img-fluid rounded-circle" src="../../../../../assets/images/warehouse.png">
                        </div>
                    </div>
                    <div class="card-body mt-0 p-t-0 p-b-0">
                        <hr class="m-t-0">
                        <h5 class="mb-0">{{warehouse.name}}</h5>
                        <span class="" v-html="warehouse.description"/>
                        <hr>
                        <address class="mt-2">
                            <strong><i class="fas fa-map-marked-alt"/></strong><br>
                            {{warehouse.address.line1}}<br>
                            <span v-if="warehouse.address.line2">{{warehouse.address.line2}}<br></span>
                            {{warehouse.address.city}}, {{warehouse.address.state}}<br>
                            {{warehouse.address.postal_code}}, {{warehouse.address.country}}<br>
                        </address>
                    </div>
                    <div class="card-footer p-t-0 p-b-0 mb-3">
                        <hr class="m-t-0">
                        <div v-if="currentOrg.role === 'ORG_ADMIN'">
                            <router-link :to="{ name: 'editmarketplacewarehouse', params: {warehouseid: warehouseid}}"
                                         class="btn btn-info ml-auto">Edit
                            </router-link>

                            <button class="btn btn-secondary float-right">Delete</button>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-lg-9">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-blue">
                            <div class="card-header">
                                <h4 class="card-title">Goods</h4>
                                <h5 class="card-subtitle">Current Inventory of Goods</h5>
                            </div>

                            <div class="card-body">
                                <div class="table-responsive">
                                    <div class="col-md-12">
                                        <div class="row mt-1 mb-2">
                                            <div class="col-lg-6">
                                                <div class="input-group">
                                                    <input class="form-control" placeholder="Search By Good Name"
                                                           type="text" v-model="searchInv">
                                                    <div class="input-group-append">
                                                        <button @click="getInventories(1)"
                                                                class="btn btn-light btn-outline-success font-weight-bold"
                                                                type="button">
                                                            <i class="fa fa-search"/> Go!
                                                        </button>
                                                        <button @click="resetInv()"
                                                                class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold"
                                                                type="button">
                                                            <i class="fa fa-undo"/> Reset
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-4">
                                                <div class="btn-group">
                                                    <router-link :to="{name: 'add-commodity-to-warehouse'}"
                                                                 class="btn btn-outline-success"
                                                                 title="Add stock to Warehouse">
                                                        Add
                                                    </router-link>
                                                    <router-link :to="{name: 'transfer-commodity-from-warehouse'}"
                                                                 class="btn btn-outline-info"
                                                                 title="Transfer stock to Another Warehouse">
                                                        Transfer
                                                    </router-link>
                                                    <router-link :to="{name: 'challan-from-warehouse'}"
                                                                 class="btn btn-outline-dark"
                                                                 title="Create Challan">
                                                        Challan
                                                    </router-link>
                                                    <router-link :to="{name: 'deduct-commodity-from-warehouse'}"
                                                                 class="btn btn-outline-danger"
                                                                 title="Deduct stock from Warehouse">
                                                        Deduct
                                                    </router-link>
                                                </div>
                                            </div>

                                            <div class="col-2 text-right">
                                                <span class="fa-xs fa-stack fa-1x ml-auto text-muted"
                                                      title="Exporting, please wait ..."
                                                      v-if="exporting">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>
                                        </span>
                                                <button aria-expanded="false" aria-haspopup="true"
                                                        class="btn waves-effect waves-light btn-outline-info"
                                                        data-toggle="dropdown" title="Operations">
                                                    <i class="fa fa-grip-vertical"/>
                                                </button>
                                                <div class="dropdown-menu">
                                                    <a @click="exportStockAsExcel()" class="dropdown-item"
                                                       href="javascript:void(0)">
                                                        <i class="fa fa-file-excel"/> Export
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <table class="table no-wrap v-top" v-if="inventories.length >0">
                                        <thead>
                                        <tr class="border-0 bg-light">
                                            <th class="border-0"><h6>Name</h6></th>
                                            <th class="border-0"><h6>Variety</h6></th>
                                            <th class="border-0"><h6>Category</h6></th>
                                            <th class="border-0 text-right"><h6>Available Quantity</h6></th>
                                            <th class="border-0 text-center"><h6>Unit</h6></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-bind:key="index" v-for="(t, index) in inventories">
                                            <td>{{t.name}}</td>
                                            <td>{{t.variety}}</td>
                                            <td>
                                                <goods-services-category :category="t.category"/>
                                            </td>
                                            <td class="text-right">{{t.stock | unitFix(2)}}</td>
                                            <td class="text-center">{{t.unit}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <template v-else>
                                        <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                                        <h5 class="card-title text-muted text-center m-b-30">Change search criteria and
                                            try again</h5>
                                    </template>
                                </div>
                            </div>

                            <div class="card-footer" v-if="inventories.length>0">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="row">
                                            <label class="col-form-label p-l-10" for="records">Display</label>
                                            <div class="col-auto p-t-5">
                                                <select @change="perPageRecordChangeInv()" aria-controls="lang_opt"
                                                        class="form-control form-control-sm" name="lang_opt_length"
                                                        v-model="perPageInv">
                                                    <option value="5">5</option>
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>
                                            </div>
                                            <label class="col-form-label" for="records">Records per page</label>
                                        </div>
                                    </div>

                                    <div class="col-6">
                                        <paginate
                                                :click-handler="pageHandlerInv"
                                                :container-class="'pagination float-right mb-0'"
                                                :margin-pages="2"
                                                :next-class="'page-link'"
                                                :next-text="'Next'"
                                                :page-class="'page-link'"
                                                :page-count=pageCountInv
                                                :page-range="3"
                                                :prev-class="'page-link'"
                                                :prev-text="'Prev'">
                                        </paginate>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="card card-blue">
                            <div class="card-header">
                                <h4 class="card-title">Logs</h4>
                                <h5 class="card-subtitle">Recent Goods Transactions</h5>
                            </div>

                            <div class="card-body">
                                <div class="table-responsive">
                                    <div class="col-md-12">
                                        <div class="form-group row">
                                            <div class="col-md-4 col-sm-12">
                                                <input class="form-control" placeholder="Batch Number" type="text"
                                                       v-model="txnFilter.batch">
                                            </div>

                                            <div class="col-md-4 col-sm-12">
                                                <multiselect
                                                        :clear-on-select="false"
                                                        :close-on-select="true"
                                                        :hide-selected="true"
                                                        :internal-search="false"
                                                        :options="txnGoods"
                                                        :searchable="true"
                                                        :selectLabel="''"
                                                        :show-no-results="false"
                                                        @search-change="txnFilterGoods"
                                                        class="form-control multiselect-sm"
                                                        id="goodtxn"
                                                        label="Search Good"
                                                        name="customer"
                                                        open-direction="bottom"
                                                        placeholder="Search Good"
                                                        v-model="txnFilter.good">
                                                    <template slot="singleLabel" slot-scope="props">
                                                        <div class="option__desc">
                                                            <div class="option__desc"
                                                                 style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                                                {{ props.option.commodity_name }} - {{
                                                                props.option.variety }}
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template slot="option" slot-scope="props">
                                                        <div class="option__desc">
                                                            <div class="option__desc" v-if="props.option">
                                                                <h5>{{ props.option.commodity_name }}</h5>
                                                                {{ props.option.variety}}
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <span slot="noResult">Good not found</span>
                                                </multiselect>
                                            </div>

                                            <div class="col-md-4 col-sm-12">
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <button aria-expanded="false"
                                                                aria-haspopup="true"
                                                                class="btn btn-light waves-effect border"
                                                                data-toggle="dropdown">
                                                            {{txnFilter.comp}}
                                                        </button>
                                                        <div aria-labelledby="dropdownMenuLink" class="dropdown-menu">
                                                            <a @click="txnFilter.comp = '='" class="dropdown-item"
                                                               href="#">= Equals To</a>
                                                            <a @click="txnFilter.comp = '>'" class="dropdown-item"
                                                               href="#">&lt; Greater Than</a>
                                                            <a @click="txnFilter.comp = '<'" class="dropdown-item"
                                                               href="#">&gt; Less Than</a>
                                                        </div>
                                                    </div>
                                                    <input class="form-control" placeholder="Quantity" type="number"
                                                           v-model="txnFilter.quantity">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-md-4 col-sm-12">
                                                <multiselect :options="['Add','Receive','Deduct','Transfer','Challan']"
                                                             class="form-control multiselect-sm"
                                                             placeholder="Select Type"
                                                             v-model="txnFilter.type">
                                                </multiselect>
                                            </div>

                                            <div class="col-md-2 col-sm-6">
                                                <input class="form-control" id="startdate" placeholder="Start Date"
                                                       type="text"/>
                                            </div>

                                            <div class="col-md-2 col-sm-6">
                                                <input class="form-control" id="enddate" placeholder="End Date"
                                                       type="text"/>
                                            </div>

                                            <div class="col-2">
                                                <div class="btn-group" style="display: flex;">
                                                    <button @click="getTransactions(1)"
                                                            class="btn btn-light btn-outline-success font-weight-bold"
                                                            style="flex: 1" type="button">
                                                        <i class="fa fa-search"/> Go!
                                                    </button>
                                                    <button @click="reset()"
                                                            class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold"
                                                            style="flex: 1" type="button">
                                                        <i class="fa fa-undo"/> Reset
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="col-2 text-right">
                                                <span class="fa-xs fa-stack fa-1x ml-auto text-muted"
                                                      title="Exporting, please wait ..." v-if="exportingInv">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>
                                        </span>
                                                <button aria-expanded="false" aria-haspopup="true"
                                                        class="btn waves-effect waves-light btn-outline-info"
                                                        data-toggle="dropdown" title="Operations">
                                                    <i class="fa fa-grip-vertical"/>
                                                </button>
                                                <div class="dropdown-menu">
                                                    <a @click="exportInvAsExcel()" class="dropdown-item"
                                                       href="javascript:void(0)">
                                                        <i class="fa fa-file-excel"/> Export
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <table class="table no-wrap v-top" v-if="transactions.length>0">
                                        <thead>
                                        <tr class="border-0 bg-light">
                                            <th class="border-0"><h6>Batch No</h6></th>
                                            <th class="border-0"><h6>Good</h6></th>
                                            <th class="border-0 text-right"><h6>Quantity</h6></th>
                                            <th class="border-0 text-center"><h6>In/Out</h6></th>
                                            <th class="border-0"><h6>Timestamp</h6></th>
                                            <th class="border-0 text-center"><h6>Action</h6></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-bind:key="index" v-for="(t, index) in transactions">
                                            <td>{{t.number}}</td>
                                            <td>{{t.name}} - {{t.variety}}</td>
                                            <td class="text-right">{{t.quantity < 0 ? -1 * t.quantity : t.quantity |
                                                unitFix(2)}} {{t.unit}}
                                            </td>
                                            <td class="text-center">
                                                <warehouse-transaction-status :transaction="t"/>
                                            </td>
                                            <td>{{t.created_at | long}}</td>
                                            <td class="text-center pt-2 pb-0">
                                                <div class="btn-group">
                                                    <button :data-content="t.ref"
                                                            :data-title="`Remarks by ${t.first_name} ${t.last_name}`"
                                                            class="btn btn-sm btn-outline-info mb-0"
                                                            data-animation="true"
                                                            data-toggle="popover"
                                                            data-trigger="focus">
                                                        <i class="fa fa-2x fa-comment-dots"/>
                                                    </button>
                                                    <button aria-expanded="false" aria-haspopup="true"
                                                            class="btn waves-effect waves-light btn-outline-info"
                                                            data-toggle="dropdown"
                                                            style="border-top-right-radius: 5px;border-bottom-right-radius: 5px;"
                                                            title="Options">
                                                        <i class="fa fa-ellipsis-v"/>
                                                    </button>
                                                    <div class="dropdown-menu">
                                                        <router-link
                                                                :to="{name: 'marketplaceviewchallan', params : { challanid: t.challan_id}}"
                                                                class="dropdown-item"
                                                                href="javascript:void(0)"
                                                                v-if="t.challan_id">View Challan
                                                        </router-link>
                                                        <a class="dropdown-item" href="javascript:void(0)" v-else>
                                                            No Options
                                                        </a>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <template v-else>
                                        <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                                        <h5 class="card-title text-muted text-center m-b-30">Change search criteria and
                                            try again</h5>
                                    </template>
                                </div>
                            </div>

                            <div class="card-footer" v-if="transactions.length>0">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="row">
                                            <label class="col-form-label p-l-10" for="records">Display</label>
                                            <div class="col-auto p-t-5">
                                                <select @change="perPageRecordChange()" aria-controls="lang_opt"
                                                        class="form-control form-control-sm" id="records"
                                                        name="lang_opt_length"
                                                        v-model="perPage">
                                                    <option value="5">5</option>
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>
                                            </div>
                                            <label class="col-form-label" for="records">Records per page</label>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <paginate
                                                :click-handler="pageHandler"
                                                :container-class="'pagination float-right mb-0'"
                                                :margin-pages="2"
                                                :next-class="'page-link'"
                                                :next-text="'Next'"
                                                :page-class="'page-link'"
                                                :page-count=pageCount
                                                :page-range="3"
                                                :prev-class="'page-link'"
                                                :prev-text="'Prev'">
                                        </paginate>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="addGoodModal" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add stock to Warehouse</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit.prevent="handleSubmitAdd" data-vv-scope="add">
                        <div class="modal-body">
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label">Good</label>
                                <div class="col-sm-7">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('add.goodsservice')}"
                                                 :clear-on-select="false"
                                                 :close-on-select="true"
                                                 :hide-selected="true"
                                                 :internal-search="false"
                                                 :limit="3"
                                                 :max-height="600"
                                                 :options="goods"
                                                 :options-limit="300"
                                                 :searchable="true"
                                                 :show-no-results="false"
                                                 @input="setUnit()"
                                                 @search-change="searchGoods"
                                                 class="form-control multiselect-sm"
                                                 data-vv-as="Good"
                                                 id="goodsservice"
                                                 label="goodsservice"
                                                 name="goodsservice"
                                                 open-direction="bottom"
                                                 placeholder="Search Goods/Service"
                                                 selectLabel=""
                                                 track-by="id"
                                                 v-model="addGood.good"
                                                 v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc"
                                                     style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                                    {{ props.option.commodity_name }} - {{ props.option.variety }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.commodity_name }}</h5>
                                                    {{ props.option.variety}}
                                                </div>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('add.goodsservice')">{{
                                        errors.first('add.goodsservice') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label">Quantity</label>
                                <div class="col-sm-7">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('add.quantity')}"
                                               class="form-control"
                                               data-vv-as="Quantity"
                                               id="quantity"
                                               name="quantity"
                                               placeholder="Quantity"
                                               step="any"
                                               type="number"
                                               v-model="addGood.quantity"
                                               v-validate="'required','min_value:0'">
                                        <input :class="{'is-invalid': submitted && errors.has('add.quantity')}"
                                               :value="addGood.unit" class="form-control" disabled
                                               style="max-width: 40px">
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('add.quantity')">{{ errors.first('add.quantity')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label">Remarks</label>
                                <div class="col-sm-7">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('add.ref')}"
                                               class="form-control"
                                               data-vv-as="Remarks"
                                               id="ref"
                                               name="ref"
                                               placeholder="Remarks"
                                               type="text"
                                               v-model="addGood.ref"
                                               v-validate="'required'">
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('add.ref')">{{ errors.first('add.ref') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary" type="submit">Submit</button>
                            <button class="btn btn-secondary" data-dismiss="modal" type="reset">Close</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal" id="transferGoodModal" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Transfer stock to Other Warehouse</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit.prevent="handleSubmitTrf" data-vv-scope="trf">
                        <div class="modal-body">
                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label">Warehouse</label>
                                <div class="col-sm-10">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('trf.warehouse')}"
                                                 :clear-on-select="false"
                                                 :close-on-select="true"
                                                 :hide-selected="true"
                                                 :internal-search="false"
                                                 :limit="3"
                                                 :max-height="600"
                                                 :options="warehouses"
                                                 :options-limit="300"
                                                 :searchable="true"
                                                 :show-no-results="false"
                                                 @search-change="searchWareHouses"
                                                 class="form-control multiselect-sm"
                                                 data-vv-as="Warehouse"
                                                 id="Warehouse1"
                                                 label="goodsservice"
                                                 name="warehouse"
                                                 open-direction="bottom"
                                                 placeholder="Search Warehouse"
                                                 selectLabel=""
                                                 track-by="id"
                                                 v-model="trfGood.warehouse"
                                                 v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.name }}</h5>
                                                    {{ props.option.description }}
                                                </div>
                                                <div class="option__desc" v-else>
                                                    <h5>Add New</h5>
                                                </div>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('trf.warehouse')">{{
                                        errors.first('trf.warehouse') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label">Good</label>
                                <div class="col-sm-10">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('trf.goodsservice')}"
                                                 :clear-on-select="false"
                                                 :close-on-select="true"
                                                 :hide-selected="true"
                                                 :internal-search="false"
                                                 :limit="3"
                                                 :max-height="600"
                                                 :options="invGoods"
                                                 :options-limit="300"
                                                 :searchable="true"
                                                 :show-no-results="false"
                                                 @input="getLogsByGood('')"
                                                 @search-change="filterGoods"
                                                 class="form-control multiselect-sm "
                                                 data-vv-as="Good"
                                                 id="goodsservice1"
                                                 label="goodsservice"
                                                 name="goodsservice"
                                                 open-direction="bottom"
                                                 placeholder="Search Goods/Service"
                                                 selectLabel=""
                                                 track-by="id"
                                                 v-model="trfGood.good"
                                                 v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc"
                                                     style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                                    {{ props.option.name }} - {{ props.option.variety }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.name }} - {{ props.option.variety }}</h5>
                                                    <p><b>Available: </b>{{props.option.stock | unitFix(2)}}
                                                        {{props.option.unit}}</p>
                                                </div>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('trf.goodsservice')">{{
                                        errors.first('trf.goodsservice') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label">Batch</label>
                                <div class="col-sm-10">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('trf.batch')}"
                                                 :clear-on-select="false"
                                                 :close-on-select="true"
                                                 :hide-selected="false"
                                                 :internal-search="false"
                                                 :limit="3"
                                                 :max-height="600"
                                                 :options="logs_by_good"
                                                 :options-limit="300"
                                                 :searchable="true"
                                                 :show-no-results="false"
                                                 @input="addBatch(selected_batch)"
                                                 @search-change="getLogsByGood"
                                                 class="form-control multiselect-sm "
                                                 data-vv-as="Batch"
                                                 id="batch"
                                                 label="batch"
                                                 name="batch"
                                                 open-direction="bottom"
                                                 placeholder="Search Batch"
                                                 ref="selectedItem"
                                                 selectLabel=""
                                                 track-by="id"
                                                 v-model="selected_batch"
                                                 v-validate="''">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc"
                                                     style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                                    {{props.option.number}}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <h5>{{props.option.number}} - {{props.option.quantity | unitFix(2)}}
                                                {{props.option.unit}}</h5>
                                            <span>{{props.option.created_at | medium}}</span>
                                        </template>
                                        <span slot="noResult">Oops! No batches found. Consider changing the search query.</span>
                                    </multiselect>
                                </div>
                            </div>

                            <div class="row" v-if="batches.length>0">
                                <label class="col-sm-2 text-right control-label col-form-label"></label>
                                <div class="col-sm-10">
                                    <ul class="select2-selection__rendered custom-flex">
                                        <li :id="b" class="selection-choice2" data-select2-id="346" title="blue"
                                            v-for="(b, index) in batches">
                                            {{b.number}}<span @click="removeBatch(b)" class="select-remove"> ×</span>
                                        </li>
                                        <li @click="removeAllBatch()" class="remove-all" v-if="batches.length>1"><u>Clear
                                            all</u></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label">Quantity</label>
                                <div class="col-sm-10">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('trf.quantity')}"
                                               class="form-control"
                                               data-vv-as="Quantity"
                                               id="quantity1"
                                               name="quantity"
                                               placeholder="Quantity"
                                               step="any"
                                               type="number"
                                               v-model="trfGood.quantity"
                                               v-validate="'required', `between:1,${trfGood.limit}`">
                                        <p :value="trfGood.unit" class="form-control" disabled
                                           style="max-width: 40px"></p>
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('trf.quantity')">{{ errors.first('trf.quantity')
                                        }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label">Remarks</label>
                                <div class="col-sm-10">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('trf.ref')}"
                                               class="form-control"
                                               data-vv-as="Remarks"
                                               id="ref1"
                                               name="ref"
                                               placeholder="Remarks"
                                               type="text"
                                               v-model="trfGood.ref"
                                               v-validate="'required'">
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('trf.ref')">{{ errors.first('trf.ref') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary" type="submit">Submit</button>
                            <button class="btn btn-secondary" data-dismiss="modal" type="reset">Close</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal" id="deductGoodModal" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Deduct stock from Warehouse</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit.prevent="handleSubmitDed" data-vv-scope="ded">
                        <div class="modal-body">
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label">Good</label>
                                <div class="col-sm-7">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('ded.goodsservice')}"
                                                 :clear-on-select="false"
                                                 :close-on-select="true"
                                                 :hide-selected="true"
                                                 :internal-search="false"
                                                 :limit="3"
                                                 :max-height="600"
                                                 :options="invGoods"
                                                 :options-limit="300"
                                                 :searchable="true"
                                                 :show-no-results="false"
                                                 @input="setUnitDed()"
                                                 @search-change="filterGoods"
                                                 class="form-control multiselect-sm"
                                                 data-vv-as="Good"
                                                 id="goodsservice2"
                                                 label="goodsservice"
                                                 name="goodsservice"
                                                 open-direction="bottom"
                                                 placeholder="Search Goods/Service"
                                                 selectLabel=""
                                                 track-by="id"
                                                 v-model="dedGood.good"
                                                 v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc"
                                                     style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                                    {{ props.option.name }} - {{ props.option.variety }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.name }}</h5>
                                                    {{ props.option.variety}}
                                                </div>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('ded.goodsservice')">{{
                                        errors.first('ded.goodsservice') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label">Quantity</label>
                                <div class="col-sm-7">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('ded.quantity')}"
                                               class="form-control"
                                               data-vv-as="Quantity"
                                               id="quantity3"
                                               name="quantity"
                                               placeholder="Quantity"
                                               step="any"
                                               type="number"
                                               v-model="dedGood.quantity"
                                               v-validate="'required',`between:0,${dedGood.limit}`">
                                        <input :class="{'is-invalid': submitted && errors.has('ded.quantity')}"
                                               :value="dedGood.unit" class="form-control" disabled
                                               style="max-width: 40px">
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('ded.quantity')">{{ errors.first('ded.quantity')
                                        }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label">Remarks</label>
                                <div class="col-sm-7">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('ded.ref')}"
                                               class="form-control"
                                               data-vv-as="Remarks"
                                               id="ref3"
                                               name="ref"
                                               placeholder="Remarks"
                                               type="text"
                                               v-model="dedGood.ref"
                                               v-validate="'required'">
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('ded.ref')">{{ errors.first('ded.ref') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary" type="submit">Submit</button>
                            <button class="btn btn-secondary" data-dismiss="modal" type="reset">Close</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal" id="createChallanModal" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create Challan</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit.prevent="handleSubmitChn" data-vv-scope="chn">
                        <div class="modal-body">
                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label">Buyer:</label>
                                <div class="col-sm-8">
                                    <multiselect
                                            :class="{'is-invalid': submitted && errors.has('chn.buyer')}"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :loading="isLoading"
                                            :options="partners"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @search-change="searchPartners"
                                            class="form-control multiselect-sm"
                                            data-vv-as="Buyer"
                                            label="buyer"
                                            name="buyer"
                                            open-direction="bottom"
                                            placeholder="Search Buyer"
                                            track-by="id"
                                            v-model="challan.buyer"
                                            v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.org_name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.org_name }}</h5>
                                                </div>
                                                <div class="option__desc" v-else>
                                                    <h5>Add New</h5>
                                                </div>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('chn.buyer')">{{ errors.first('chn.buyer') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label">Reference:</label>
                                <div class="col-sm-8">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('chn.ref')}"
                                               class="form-control"
                                               data-vv-as="Challan Reference"
                                               id="ref2"
                                               name="ref"
                                               placeholder="Reference"
                                               type="text"
                                               v-model="challan.ref"
                                               v-validate="'required'">
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('chn.ref')">{{ errors.first('chn.ref') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row" v-for=" (item,i) in challan.items">
                                <label class="col-sm-2 text-right control-label col-form-label">Item {{i+1}}:</label>
                                <div class="col-sm-4">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('chn.goodsservice'+i)}"
                                                 :clear-on-select="false"
                                                 :close-on-select="true"
                                                 :hide-selected="true"
                                                 :id="'goodsservice3'+i"
                                                 :internal-search="false"
                                                 :limit="3"
                                                 :loading="isLoading"
                                                 :max-height="600"
                                                 :name="'goodsservice'+i"
                                                 :options="invGoods"
                                                 :options-limit="300"
                                                 :searchable="true"
                                                 :show-no-results="false"
                                                 @input="setUnitChn(item)"
                                                 @search-change="filterGoods"
                                                 class="form-control multiselect-sm"
                                                 data-vv-as="Good"
                                                 label="goodsservice"
                                                 open-direction="bottom"
                                                 placeholder="Search Goods/Service"
                                                 selectLabel=""
                                                 track-by="id"
                                                 v-model="item.good"
                                                 v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc"
                                                     style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                                    {{ props.option.name }} - {{ props.option.variety }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.name }}</h5>
                                                    <h6>{{ props.option.variety }}</h6>
                                                    Available Quantity {{ props.option.stock | unitFix(2)
                                                    }}{{props.option.unit}}
                                                </div>
                                                <div class="option__desc" v-else>
                                                    <h5>Add New</h5>
                                                </div>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('chn.goodsservice'+i)">
                                        {{ errors.first('chn.goodsservice'+i) }}
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('chn.quantity'+i)}"
                                               :id="'quantity3'+i"
                                               :name="'quantity'+i"
                                               class="form-control"
                                               data-vv-as="Quantity"
                                               placeholder="Quantity"
                                               step="any"
                                               type="number"
                                               v-model="item.quantity"
                                               v-validate="'required',`between:0,${item.limit}`">
                                        <input :class="{'is-invalid': submitted && errors.has('chn.quantity'+i)}"
                                               :value="item.unit" class="form-control" disabled
                                               style="max-width: 40px">
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('chn.quantity'+i)">{{
                                        errors.first('chn.quantity'+i) }}
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <button @click="addItem" class="btn btn-success mr-2" title="Add More Item"
                                            type="button" v-if="i===challan.items.length-1">
                                        <i class="fa fa-plus"/>
                                    </button>
                                    <button @click="removeItem(i)" class="btn btn-danger" title="Remove This Item"
                                            type="button" v-if="challan.items.length != 1">
                                        <i class="fa fa-minus"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary" type="submit">Submit</button>
                            <button class="btn btn-secondary" data-dismiss="modal" type="reset">Close</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';
    import _ from 'lodash';
    import Multiselect from 'vue-multiselect';
    import countries from "../../../../../assets/js/countries.json";
    import WarehouseTransactionStatus from "../MarWarehouseTransactionStatus";
    import XLSX from "xlsx";
    import GoodsServicesCategory from "../../../express/purchases/goods-services/GoodsServicesCategory";

    export default {
        name: "ViewmarketplaceWarehouse",
        props: ["marketplaceid", "warehouseid"],
        components: {GoodsServicesCategory, Paginate, Multiselect, WarehouseTransactionStatus},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                countries: countries,
                warehouse: {
                    name: null,
                    description: null,
                    address: {
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        postal_code: null,
                        country: null
                    },
                    inventory: []
                },
                transactions: [],
                pageCount: 1,
                total: 0,
                perPage: 5,
                search: null,
                exporting: false,
                inventories: [],
                pageCountInv: 1,
                totalInv: 0,
                perPageInv: 5,
                searchInv: null,
                exportingInv: false,
                warehouses: [],
                goods: [],
                invGoods: [],
                addGood: {
                    good: null,
                    quantity: null,
                    unit: null,
                    ref: null,
                },
                trfGood: {
                    warehouse: null,
                    good: null,
                    quantity: null,
                    unit: null,
                    ref: null,
                    limit: 0
                },
                dedGood: {
                    good: null,
                    quantity: null,
                    unit: null,
                    ref: null,
                    limit: 0
                },
                challan: {
                    buyer: null,
                    items: [{
                        good: null,
                        quantity: null,
                        unit: null,
                        limit: 0
                    }],
                    ref: null
                },
                partners: [],
                isLoading: false,
                submitted: false,
                txnGoods: [],
                txnFilter: {
                    batch: null,
                    warehouse: null,
                    good: null,
                    quantity: null,
                    comp: '=',
                    startedate: null,
                    enddate: null
                },
                logs_by_good: [],
                logs_by_good_bkp: [],
                batches: [],
                selected_batch: null
            }
        },
        mounted() {
            let self = this;
            $(function () {
                $('#startdate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.txnFilter.startdate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.txnFilter.startdate = null;
                        }
                    });

                $('#enddate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.txnFilter.enddate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.txnFilter.enddate = null;
                        }
                    });

                $('#addGoodModal').on('hidden.bs.modal', (e) => {
                    this.addGood = {
                        good: null,
                        quantity: null,
                        unit: null,
                        ref: null,
                    };
                    this.submitted = false
                });
                $('#transferGoodModal').on('hidden.bs.modal', (e) => {
                    this.trfGood = {
                        warehouse: null,
                        good: null,
                        quantity: null,
                        unit: null,
                        ref: null,
                        limit: 0
                    };
                    this.submitted = false;
                });
                $('#deductGoodModal').on('hidden.bs.modal', (e) => {
                    this.dedGood = {
                        good: null,
                        quantity: null,
                        unit: null,
                        ref: null,
                        limit: 0
                    },
                        this.submitted = false;
                });
                // $('#createChallanModal').on('hidden.bs.modal', (e) => {
                //     this.challan.items = [{
                //         good: null,
                //         quantity: null,
                //         unit: null,
                //         limit: 0
                //     }];
                //     this.challan.buyer = null,
                //         this.challan.ref = null;
                //     this.submitted = false;
                // });
            });
            this.init();
        },
        methods: {
            async init() {
                try {
                    $(".preloader").fadeIn();
                    await Promise.all([
                        this.getWareHouse(),
                        this.getTransactions(1)
                    ]);
                } catch (e) {
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async getWareHouse() {
                let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}`);
                this.warehouse = reply.data;
                this.getInventories(1);
            },
            async getTransactions(page) {
                let filter = {};

                if (this.txnFilter.batch) {
                    filter.batch = this.txnFilter.batch;
                }

                if (this.txnFilter.good) {
                    filter.goodid = this.txnFilter.good.id;
                }

                if (this.txnFilter.quantity) {
                    filter.quantity = this.txnFilter.quantity;
                    filter.comp = this.txnFilter.comp;
                }

                if (this.txnFilter.startdate) {
                    filter.start = this.txnFilter.startdate;
                }

                if (this.txnFilter.enddate) {
                    filter.end = this.txnFilter.enddate;
                }

                if (this.txnFilter.type) {
                    filter.type = this.txnFilter.type;
                }

                let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}/transactions`, {
                    params: {
                        page: page,
                        perPage: this.perPage,
                        ...filter
                    }
                });

                this.total = reply.data.total;
                this.transactions = reply.data.transactions;
                this.setPageCount();
                $(function () {
                    $('[data-toggle="popover"]').popover({
                        show: function () {
                            $(this).fadeIn('slow');
                        }
                    })
                });
            },
            getInventories(page) {

                let inventories = this.warehouse.inventory;
                if (this.searchInv) {
                    inventories = _.filter(this.warehouse.inventory, (e) => {
                        return e.name.indexOf(this.searchInv) !== -1;
                    })
                }

                this.totalInv = inventories.length;
                let start = (page - 1) * this.perPageInv;
                let end = start + this.perPageInv;
                this.inventories = inventories.slice(start, end);
                this.setPageCountInv();

            },
            pageHandler(pageNum) {
                this.getTransactions(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            perPageRecordChange() {
                if (this.isFiltered) {
                    this.getTransactions(1);
                } else {
                    this.getTransactions(1);
                }
            },
            pageHandlerInv(pageNum) {
                this.getInventories(pageNum);
            },
            setPageCountInv() {
                this.pageCountInv = this.totalInv <= this.perPageInv ? 1 : Math.ceil(this.totalInv / this.perPageInv);
            },
            perPageRecordChangeInv() {
                if (this.isFiltered) {
                    this.getInventories(1);
                } else {
                    this.getInventories(1);
                }
            },
            async reset() {
                this.txnFilter = {
                    batch: null,
                    warehouse: null,
                    good: null,
                    quantity: null,
                    comp: '=',
                    startedate: null,
                    enddate: null
                };
                await this.getTransactions(1);
            },
            resetInv() {
                this.searchInv = null;
                this.getInventories(1);
            },
            async searchWareHouses(search) {
                let reply = await this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses`, {
                        params: {
                            search
                        }
                    });
                this.warehouses = _.filter(reply.data.warehouses, (w) => {
                    return w.id !== Number(this.warehouseid)
                });
            },
            async searchGoods(search) {
                this.isLoading = true;
                let reply = await this.$http.get("/marketplaces/" + this.marketplaceid + "/commodities/search", {
                    params: {
                        search,
                        excludeOld: true
                    }
                });
                this.goods = reply.data;
            },
            filterGoods(searchtxt) {
                this.invGoods = _.filter(this.warehouse.inventory, (inv) => {
                    return inv.name.indexOf(searchtxt) !== -1 && inv.category !== 'OLD'
                });
            },

            setUnit() {
                if (!this.addGood.good.rate.amount) {
                    $('#addGoodModal').modal('hide')
                    this.$toastr('warning', 'Commodity rate is not set, edit commodity and set rate', 'Warning');
                    this.$router.push({
                        name: "viewcommodity",
                        params: {commodityid: this.addGood.good.commodity_id}
                    });
                } else {
                    this.addGood.unit = this.addGood.good ? this.addGood.good.unit.symbol : null;
                }
            },
            handleSubmitAdd() {
                this.submitted = true;
                this.$validator.validateAll('add')
                    .then(valid => {
                        if (valid) {
                            this.addGoodToWarehouse();
                        }
                    });
            },
            async addGoodToWarehouse() {
                try {
                    let payload = {
                        commodity_id: this.addGood.good.commodity_id,
                        quantity: this.addGood.quantity,
                        unit_id: this.addGood.good.unit_id,
                        ref: this.addGood.ref
                    }
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}/add`, payload)
                    await this.init();
                    this.$toastr('success', 'Good add to warehouse', 'Success');
                } catch (e) {
                    this.$toastr('error', 'Could not add stock to warehouse', 'Failed');
                } finally {
                    $('#addGoodModal').modal('hide')
                }
            },
            setUnitTrf() {
                console.log(this.trfGood);
                this.trfGood.unit = this.trfGood.good ? this.trfGood.good.unit : null;
                this.trfGood.limit = this.trfGood.good ? Number(this.trfGood.good.stock) : 0;
            },
            handleSubmitTrf() {
                this.submitted = true;
                this.$validator.validateAll('trf')
                    .then(valid => {
                        if (valid) {
                            this.transferGoodToWarehouse();
                        }
                    });
            },
            async transferGoodToWarehouse() {
                try {
                    let payload = {
                        warehouse_id: this.trfGood.warehouse.id,
                        commodity_id: this.trfGood.good.id,
                        quantity: this.trfGood.quantity,
                        unit_id: this.trfGood.good.unit_id,
                        ref: this.trfGood.ref,
                        batches: this.batches.map(b => b.number)
                    }
                    let {data} = await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}/transfer`, payload)
                    this.invGoods = [];
                    $('#transferGoodModal').modal('hide')
                    await this.$router.push({
                        name: 'viewdeliverynote',
                        params: {deliverynoteid: data.delivery_note_id}
                    });
                    // await this.init();
                    this.$toastr('success', 'Good transferred to warehouse', 'Success');
                } catch (e) {
                    console.error(e)
                    this.$toastr('error', 'Could not transfer stock to warehouse', 'Failed');
                } finally {
                    $('#transferGoodModal').modal('hide')
                }
            },
            async createDeliveryNote() {
                try {

                } catch (e) {

                }
            },
            setUnitDed() {
                this.dedGood.unit = this.dedGood.good ? this.dedGood.good.unit : null;
                this.dedGood.limit = this.dedGood.good ? Number(this.dedGood.good.stock) : 0;
            },
            handleSubmitDed() {
                this.submitted = true;
                this.$validator.validateAll('ded')
                    .then(valid => {
                        if (valid) {
                            this.deductGoodFromWarehouse();
                        }
                    });
            },
            async deductGoodFromWarehouse() {
                console.log("reqbody", this.dedGood);
                try {
                    let payload = {
                        commodity_id: this.dedGood.good.id,
                        quantity: this.dedGood.quantity,
                        unit_id: this.dedGood.good.unit_id,
                        ref: this.dedGood.ref
                    }
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}/deduct`, payload)
                    this.invGoods = [];
                    await this.init();
                    this.$toastr('success', 'Good deducted from warehouse', 'Success');
                } catch (e) {
                    console.log(e);
                    this.$toastr('error', 'Could not deduct stock to warehouse', 'Failed');
                } finally {
                    $('#deductGoodModal').modal('hide')
                }
            },
            setUnitChn(item) {
                if (item.good) {
                    let goods = _.filter(this.challan.items, (_item) => {
                        return _item.good.id === item.good.id;
                    });
                    if (goods.length === 1) {
                        item.unit = item.good.unit;
                        item.limit = Number(item.good.stock);
                    } else {
                        this.$toastr('warning', 'Item already selected', 'Warning!');
                        item.good = null;
                    }
                }
            },
            addItem() {
                this.challan.items.push({
                    good: null,
                    quantity: null,
                    unit: null,
                    limit: 0
                });
            },
            removeItem(i) {
                this.challan.items.splice(i, 1);
            },
            handleSubmitChn() {
                this.submitted = true;
                this.$validator.validateAll('chn')
                    .then(valid => {
                        if (valid) {
                            this.createChallan();
                        }
                    });
            },
            async createChallan() {
                console.log("reqbody", this.challan);
                try {
                    let payload = {
                        buyer_id: 5,
                        ref: this.challan.ref,
                        items: this.challan.items.map(ci => ({
                            commodity_id: ci.good.id,
                            quantity: ci.quantity,
                            unit_id: ci.good.unit_id
                        }))
                    };

                    let {data} = await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}/challan`, payload)
                    this.$toastr('success', 'Challan created', 'Success');
                    this.challan.items = [{
                        good: null,
                        quantity: null,
                        unit: null,
                        limit: 0
                    }];
                    this.challan.buyer = null;
                    this.challan.ref = null;
                    this.submitted = false;
                    $('#createChallanModal').modal('hide');
                    await this.$router.push({name: 'marketplaceviewchallan', params: {challanid: data.challanid}})
                } catch (e) {
                    this.$toastr('error', 'Could not create challan', 'Failed');
                } finally {
                    $('#createChallanModal').modal('hide');
                }
            },
            async txnFilterGoods(search) {
                this.isLoading = true;
                // let reply      = await this.$http.get("/marketplaces/" + this.currentOrg.marketplaceid + "/commodities/search", {
                let reply = await this.$http.get("/marketplaces/" + this.marketplaceid + "/commodities/search", {
                    params: {
                        search,
                        excludeOld: true
                    }
                });
                this.txnGoods = reply.data;
            },
            async exportStockAsExcel() {
                try {
                    this.exporting = true;
                    let inventories = this.warehouse.inventory;
                    if (this.searchInv) {
                        inventories = _.filter(this.warehouse.inventory, (e) => {
                            return e.name.indexOf(this.searchInv) !== -1;
                        })
                    }

                    let _inventories = [];

                    inventories.forEach(d => {
                        _inventories.push({
                            "Name": d.name,
                            "Description": d.description,
                            "Quantity": d.quantity,
                            "Unit": d.unit
                        })
                    });

                    let workbook = XLSX.utils.book_new();
                    let worksheet = XLSX.utils.json_to_sheet(_inventories);
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Inventories');
                    XLSX.writeFile(workbook, 'inventories.xlsx');
                } catch (e) {
                    console.error(e)
                    this.$toastr('error', 'Export failed', 'Failure');
                } finally {
                    this.exporting = false;
                }
            },
            async exportInvAsExcel() {
                try {
                    this.exportingInv = true;
                    let filter = {};

                    if (this.txnFilter.good) {
                        filter.goodid = this.txnFilter.good.id;
                    }

                    if (this.txnFilter.quantity) {
                        filter.quantity = this.txnFilter.quantity;
                        filter.comp = this.txnFilter.comp;
                    }

                    if (this.txnFilter.startdate) {
                        filter.start = this.txnFilter.startdate;
                    }

                    if (this.txnFilter.enddate) {
                        filter.end = this.txnFilter.enddate;
                    }

                    if (this.txnFilter.type) {
                        filter.type = this.txnFilter.type;
                    }

                    let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}/transactions`, {
                        params: {
                            page: 1,
                            perPage: this.total,
                            ...filter
                        }
                    });

                    this.total = reply.data.total;
                    let data = reply.data.transactions;
                    let transactions = [];
                    data.forEach(d => {
                        transactions.push({
                            "Batch": d.number,
                            "Warehouse": d.warehouse_name,
                            "Good": d.name,
                            "Quantity": Math.abs(d.quantity),
                            "Type": d.quantity >= 0 ? 'IN' : 'OUT',
                            "From": d.from,
                            "To": d.to,
                            "Unit": d.unit,
                            "Timestamp": d.created_at,
                            "Reference": d.ref,
                            "Created By": d.email
                        })
                    });

                    let workbook = XLSX.utils.book_new();
                    let worksheet = XLSX.utils.json_to_sheet(transactions);
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Transactions');
                    XLSX.writeFile(workbook, 'transactions.xlsx');
                } catch (e) {
                    console.error(e)
                    this.$toastr('error', 'Export failed', 'Failure');
                } finally {
                    this.exportingInv = false;
                }
            },
            async searchPartners(searchText) {
                try {
                    this.isLoading = true;
                    let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.partners = reply.data;
                    this.isLoading = false;
                } catch (e) {
                    console.log(e);
                }
            },
            async getLogsByGood(searchText) {
                if (this.trfGood.good) {
                    this.trfGood.unit = this.trfGood.good ? this.trfGood.good.unit : null;
                    this.trfGood.limit = this.trfGood.good ? Number(this.trfGood.good.stock) : 0;
                    try {
                        let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}/transactions`, {
                            params: {
                                goodid: this.trfGood.good.id,
                                type: 'Add',
                                batch: searchText
                            }
                        });
                        this.logs_by_good_bkp = reply.data.transactions;
                        this.logs_by_good = this.logs_by_good_bkp.filter(log => !this.batches.find(b => b.number === log.number));
                    } catch (e) {

                    }
                }
            },
            addBatch(batch) {
                this.selected_batch = null;
                this.$refs.selectedItem.deactivate();
                this.batches.push(batch);
                this.logs_by_good = this.logs_by_good.filter(log => log.number !== batch.number);
            },
            removeBatch(batch) {
                this.batches = this.batches.filter(b => b.number !== batch.number);
                this.logs_by_good.push(batch);
            },
            removeAllBatch() {
                this.batches = [];
                this.selected_batch = null;
                this.$refs.selectedItem.deactivate();
                this.logs_by_good = this.logs_by_good_bkp;
            }
        }
    }
</script>

<style scoped>
    .selection-choice2 {
        background-color: #e4e4e4;
        border-radius: 4px;
        cursor: default;
        float: left;
        margin-right: 5px;
        margin-top: 5px;
        padding: 6px 8px;
        color: #3e5569
    }

    .custom-flex {
        display: flex;
        flex-wrap: wrap;
        list-style: none;
        padding: 0
    }

    .remove-all {
        color: #999;
        cursor: pointer;
        display: inline-block;
        float: left;
        margin-right: 5px;
        margin-top: 5px;
        padding: 6px 8px;
        font-weight: bold;
    }

    .remove-all:hover {
        color: #333
    }

    .select-remove {
        color: #999;
        cursor: pointer;
        display: inline-block;
        font-weight: bold;
        margin-right: 1px;
        margin-left: 5px;
    }

    .select-remove:hover {
        color: #333
    }

    .highlight {
        color: #fff;
        background-color: #5a6268;
        border-color: #545b62;
    }
</style>
